// 柜子相关store

import { createSlice } from "@reduxjs/toolkit";
import axios from "axios";


const unitStore=createSlice({
    name:'unit',
    //定义数据状态
    initialState:{
        editingItem:{},
        formType:""
    },
    reducers:{
        //同步修改方法
        setEdtingItem(state,action){
            state.editingItem=action.payload
        },
        setFormType(state,action){
            state.formType=action.payload
        }
    }
})

//解构出来actionCreater函数
const {setEdtingItem,setFormType}=unitStore.actions

//编写异步请求
// const getUnitList=()=>{
//     return async (dispatch)=>{
//         const res = await axios.get('http://localhost:8888/unit')  
//         dispatch(seteEitingItem(res.data)) // 生成一个action对象，再使用dispatch发送给store，实现状态的更新
//     }
// }

export {setEdtingItem,setFormType} 
//导出reducer
const unitReducer=unitStore.reducer

export default unitReducer